import React, { useEffect, useState } from "react";
import { getMerchantDetls } from "../../utils/api";
import TravelQRJourney from "../../pages/travel-qr/index";
import JourneyBlocked from "../../components/JourneyBlocked";
import debug from "../../utils/debug";
import Loader from "../../components/loader";
import { useDispatch, useSelector } from "react-redux";

const JOURNEY_TYPE_TRAVEL = "QR_TRAVEL";

const JourneyMain = props => {
  const dispatch = useDispatch();
  const [isLoader, setIsLoder] = useState(false);
  const merchantDetails = useSelector(state => state.auth.merchantDetails);

  useEffect(() => {
    dispatch({ type: "SAVE_MERCHANT_DETAILS", data: null });
    const params = new URLSearchParams(document.location.search);
    let merchantId = params.get("mId");
    if (merchantId) {
      getMarchentDetails(parseInt(merchantId));
    }
  }, []);

  const getMarchentDetails = async merchantId => {
    setIsLoder(true);
    let payload = { merchantId, isQR: true };
    try {
      const { data: res } = await getMerchantDetls(payload);
      if (res.statusCode === 200) {
        dispatch({ type: "SAVE_MERCHANT_DETAILS", data: res });
        setIsLoder(false);
      } else {
        setIsLoder(false);
        debug("ERROR", "Something went wrong while get merchant info");
      }
    } catch (ex) {
      setIsLoder(false);
      debug("ERROR", ex);
    }
  };

  // Show loader while merchant info is being fetched
  if (isLoader) {
    return <Loader isLoader={isLoader} />;
  }

  // Route to travel journey when journeyType is QR_TRAVEL
  if (merchantDetails && merchantDetails.journeyType === JOURNEY_TYPE_TRAVEL) {
    return <TravelQRJourney />;
  }

  // Every other journey type is blocked -- Travel QR is the only live journey.
  return <JourneyBlocked />;
};

export default JourneyMain;
